import { UseFormReturn, FieldError } from 'react-hook-form'
import { Country, FullMeetingFragment, Currency, ObjectiveInput, NoteInfoInput, ObjectiveDto } from '../../../types'
import { NoteInfoInputExtended } from '../TargetTemplateModal/types'

export interface ObjectiveExtended extends ObjectiveInput {
  targetType?: TargetModalTargetType
  achievedAmountPercentage?: number
  markedAsDone?: boolean
}

export enum TargetModalType {
  viewTarget = 'viewTarget',
  viewTargetInMeeting = 'viewTargetInMeeting',
  appraisalNewTarget = 'appraisalNewTarget',
  appraisalNewPastTarget = 'appraisalNewPastTarget',
  appraisalEditActiveTarget = 'appraisalEditActiveTarget',
  appraisalEditPastTarget = 'appraisalEditPastTarget',
  appraisalSuggestedTarget = 'appraisalSuggestedTarget',
  resignedEmployeViewTarget = 'resignedEmployeViewTarget',
  duplicateAndDismissOrDeleteTarget = 'duplicateAndDismissOrDeleteTarget',
  duplicateAndDismissOrDeletePastTarget = 'duplicateAndDismissOrDeletePstTarget',
  deleteTarget = 'deleteTarget',
  unknown = 'unknown',
}

export enum TargetModalTargetType {
  development = 'development',
  monetary = 'monetary',
}

export interface TargetModalProps {
  employeeId?: string
  meetingId?: string
  targetBonus?: number
  alreadyPlanned?: number
  hasBonusOrWillHaveBonus?: boolean
  allowedNewTargets?: boolean
  allowedPastTargets?: boolean
  disabledMonetaryButtonTooltip?: string
  isAppraisalUpdate?: boolean
  publicProfile?: boolean
  pastTargetsPaymentView?: boolean
  employeeCurrency?: Currency | null
  meeting?: FullMeetingFragment
  employeeCountry?: Country | null
}

export interface TargetModalFormErrors {
  title: FieldError | undefined
  start: FieldError | undefined
  due: FieldError | undefined
  targetAmount: FieldError | undefined
  keyResults?: Array<{
    text: FieldError | undefined
  }>
}

export interface TargetModalState {
  isModalOpened: boolean
  targetModalType: TargetModalType
  modalProps: TargetModalProps
  currentObjective: ObjectiveInput | null
  currentAttachment: string | null | undefined
  currentComments: Array<NoteInfoInputExtended>
  commentFromInput: string | undefined
  newTargetForm: UseFormReturn<ObjectiveInput> | null
  newTargetFormErrors: TargetModalFormErrors | null
  currencyConversionRate?: number

  openTargetModal: (targetModalType: TargetModalType, objective?: ObjectiveDto, currencyConversionRate?: number) => void
  closeTargetModal: () => void
  cleanTargetModal: () => void
  setModalProps: (modalProps: TargetModalProps) => void
  cleanModalProps: () => void
  setNewTargetForm: (newTargetForm: UseFormReturn<ObjectiveInput>) => void
  setNewTargetFormErrors: (errors: TargetModalFormErrors | null) => void
  setAttachment: (attachment: string | null) => void
  addComment: (comment: NoteInfoInput) => void
  removeComment: (id: string, isNewComment?: boolean) => void
  editComment: (id: string, text: string) => void
  setCommentFromInput: (commentFromInput: string | undefined) => void
}
